var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FileTable',{ref:"fileTable",attrs:{"isAdmin":_vm.isAdmin}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('PerformanceByGrade',{attrs:{"isAdmin":_vm.isAdmin}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28cbaddc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/PerformanceCriteria/index.vue
// module id = Lnhs
// module chunks = 1